import { render } from "./PostIt.vue?vue&type=template&id=cfa15516&scoped=true"
import script from "./PostIt.vue?vue&type=script&lang=js"
export * from "./PostIt.vue?vue&type=script&lang=js"

import "./PostIt.vue?vue&type=style&index=0&id=cfa15516&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa15516"]])

export default __exports__